import React from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  Icon
} from '@polichat/flamboyant';
import { useHistory } from 'react-router-dom';

const Credits = () => {
  const history = useHistory();

  return (
      <div className="organizationsTopNav">
        <UncontrolledDropdown className="change-organizations">
          <DropdownToggle
            color="neutral"
            onClick={() => history.push('/relatorio')}
          >
            <Icon icon={'poli-icon pi-pay-fill'} size={20} color="var(--activated-icons-color)" />
            <span className="credits-header-whitelabel">Créditos</span>
          </DropdownToggle>
        </UncontrolledDropdown>
      </div>
    );
}

export { Credits }
